import { isFeatureEnabled } from 'owa-feature-flags';
import { TranslationOptions } from 'owa-outlook-service-options';
import { TranslationMode } from 'owa-translation/lib/schema/TranslationMode';
import getTranslationOptions from 'owa-translation/lib/utils/getTranslationOptions';

export default function shouldSuggestAutomatic(): boolean {
    const options: TranslationOptions = getTranslationOptions();
    return (
        isFeatureEnabled('rp-inlineTranslation-NewAutomatic') &&
        options.translationMode === TranslationMode.SuggestAutomatic
    );
}
